function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 18.333l8.333 4.167 8.334-4.167M16.333 10L8 14.167l8.333 4.166 8.334-4.166L16.333 10z",
  stroke: "#5AC49D",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgIconAimateStarter = function SvgIconAimateStarter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTguMzMzM0wxNi4zMzMzIDIyLjVMMjQuNjY2NyAxOC4zMzMzTTE2LjMzMzMgMTBMOCAxNC4xNjY3TDE2LjMzMzMgMTguMzMzM0wyNC42NjY3IDE0LjE2NjdMMTYuMzMzMyAxMFoiIHN0cm9rZT0iIzVBQzQ5RCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgIconAimateStarter as ReactComponent };